// 自定义指令，生成自定义 Tooltip
const ellipsisTooltipDirective = {
  bind(el, binding) {
    const tooltipText = binding.value;

    // 创建 Tooltip 元素
    const tooltip = document.createElement('div');
    tooltip.className = 'custom-tooltip';
    tooltip.innerText = tooltipText;
    document.body.appendChild(tooltip);

    // 设置 Tooltip 的位置并显示
    const showTooltip = (event) => {
      tooltip.style.display = 'block';
      tooltip.style.left = `${event.pageX + 10}px`;  // 位置偏移 10px
      tooltip.style.top = `${event.pageY + 10}px`;   // 位置偏移 10px
    };

    // 隐藏 Tooltip
    const hideTooltip = () => {
      tooltip.style.display = 'none';
    };

    // 检查是否溢出，并根据溢出情况显示 Tooltip
    const checkOverflow = () => {
      const isOverflowing = el.scrollWidth > el.clientWidth;

      if (isOverflowing) {
        el.addEventListener('mouseenter', showTooltip);
        el.addEventListener('mousemove', showTooltip); // 更新 Tooltip 位置
        el.addEventListener('mouseleave', hideTooltip);
      } else {
        el.removeEventListener('mouseenter', showTooltip);
        el.removeEventListener('mousemove', showTooltip);
        el.removeEventListener('mouseleave', hideTooltip);
      }
    };

    // 初始检测溢出
    checkOverflow();

    // 使用 ResizeObserver 监听元素尺寸变化
    const observer = new ResizeObserver(checkOverflow);
    observer.observe(el);

    el.__tooltipObserver__ = observer;
    el.__tooltipElement__ = tooltip; // 保存 Tooltip 元素引用
  },
  unbind(el) {
    // 移除监听器和 Tooltip 元素
    if (el.__tooltipObserver__) {
      el.__tooltipObserver__.disconnect();
      delete el.__tooltipObserver__;
    }
    if (el.__tooltipElement__) {
      el.__tooltipElement__.remove();
      delete el.__tooltipElement__;
    }
  }
}

export default ellipsisTooltipDirective
